// Sentry initialization must be first import
import { initSentry, Sentry } from './shared/lib/sentry'
initSentry()

// Expose build commit hash for debugging (access via: window.BUILD_HASH in console)
;(window as Window & { BUILD_HASH: string }).BUILD_HASH = __COMMIT_HASH__

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const container = document.getElementById('root')!

createRoot(container, {
  // React 19 error hooks for Sentry integration
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.error('Uncaught error:', error, errorInfo.componentStack)
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
